import React from 'react';
import { useParams } from 'react-router-dom';
// import { useAssessmentSectionScores } from '../hooks/useAssessmentSectionScores';
import { useAssessmentReport } from '../hooks/useGetAssessmentReport';
import { AssessmentReportNewDisplay } from '../components/assessment/AssessmentReportDisplay_NEW';

const AssessmentResult: React.FC = () => {
  const { assessmentId } = useParams<{ assessmentId: string }>();
  const { report, loading: isLoadingReport } =
    useAssessmentReport(assessmentId);

  if (isLoadingReport) {
    return <div>Loading...</div>;
  }

  if (!report) {
    return <div>No report available for this assessment.</div>;
  }

  return (
    <div>
      <h1>Assessment Result</h1>

      <AssessmentReportNewDisplay report={report} />
    </div>
  );
};

export default AssessmentResult;
